import React from 'react';
import doneMedal from '@/assets/images/doneMedal.svg';
import brilhoDireita from '@/assets/images/icons/rightBtnIcon.svg';
import brilhoEsquerda from '@/assets/images/icons/leftBtnIcon.svg';
import { useNavigate } from 'react-router-dom';
import { CardProgress, CardProgressBar, CardProgressContainer } from '@/components/ui/card';
import { MetricCard, MetricCardBody, MetricCardDescription, MetricCardMedal, MetricCardTitle } from '@/components/custom/metric';
import { Button, ButtonIcon, ButtonText } from '@/components/ui/button';

const redirectByAchievements = (title, navigate) => {
  const routes = {
    '/guia-de-estudos': ['Estudioso', 'Maratonista do Conhecimento', 'Memória de Aço', 'Explorador Completo'],
    '/curso': ['Aluno Dedicado', 'Mestre do Simulado'],
    '/feed': ['Participante Ativo'],
    '/desafio-da-semana/desafios': ['Desafiante da Semana', 'Conector de Ideias', 'Guerreiro dos Desafios', 'Campeão Consistente'],
    '/redacao': ['Escritor em Ação'],
    '/auditorio': ['Aluno Atento'],
    '/simulados': ['Mestre do Simulado']
  };

  for (const [route, titles] of Object.entries(routes)) {
    if (titles.includes(title)) {
      navigate(route);
      return;
    }
  }
};

function Card({ title, done = false, description, currentCount, totalCount, points, buttonClass }) {
  const navigate = useNavigate();

  const getButtonVariant = {
    achievements: 'primary-light',
    missions: 'mission',
    merit: 'merit'
  };

  const percentage = (currentCount / totalCount) * 100;

  return (
    <MetricCard>
      <MetricCardTitle>{title}</MetricCardTitle>

      <MetricCardBody>
        {done && (
          <MetricCardMedal
            src={doneMedal}
            alt="concluído"
          />
        )}

        <MetricCardDescription>{description}</MetricCardDescription>

        <CardProgress className="w-[152px]">
          <CardProgressContainer>
            <CardProgressBar
              className="bg-[#6FCF97]"
              percentage={percentage}
            />
          </CardProgressContainer>
          <p className="mb-0 shrink-0">
            {currentCount}/{totalCount}
          </p>
        </CardProgress>

        <Button
          variant={done ? 'done' : getButtonVariant[buttonClass]}
          border={!done}
          onClick={() => {
            if (done) return null;
            redirectByAchievements(title, navigate);
          }}
          disabled={title === 'Maratona de Missões'}
          className="disabled:opacity-100"
        >
          {!done && (
            <ButtonIcon>
              <img
                src={brilhoEsquerda}
                alt="brilho a esquerda"
              />
            </ButtonIcon>
          )}

          <ButtonText>Ganhe {points} pontos</ButtonText>

          {!done && (
            <ButtonIcon>
              <img
                src={brilhoDireita}
                alt="brilho a direita"
              />
            </ButtonIcon>
          )}
        </Button>
      </MetricCardBody>
    </MetricCard>
  );
}

export default Card;
